
export default{
    setName(state,msg){
        state.name=msg
    },
    setRoleId(state, msg) {
        state.roleId = msg;
    } ,
    setRoleName(state, msg) {
        state.roleName = msg;
    } ,
    setRoleType(state, msg) {
        state.roleType = msg;
    } ,
    setUserName(state, msg) {
        state.userName = msg;
    },
    setParallelUserName(state, msg){
        state.parallelUserName = msg;
    },
    setRealName(state, msg) {
        state.realName = msg;
    },
    setMobile(state, msg) {
        state.mobile = msg;
    },
    setEmail(state, msg) {
        state.email = msg;
    },
    setCustomerType(state, msg) {
        state.customerType = msg;
    },
    setCrumbsArr(state, msg) {
        state.crumbsArr = msg;
    },
    setMenu(state, msg) {
        state.menu = msg;
    },
    setJumpMenu(state, msg) {
        state.jumpMenu = msg;
    },
    setLogUrl(state, msg) {
        state.logUrl = msg;
    },
    setMenuWidth(state, msg) {
        state.menuWidth = msg;
    },
    setButtons(state, msg) {
        state.buttons = msg;
    },
    setTokens(state, msg) {
        state.tokens = msg;
    },
    setShopping(state, msg){
        state.shopping = msg;
    },
    setSubUser(state, msg){
        state.subUser = msg;
    },
    setCardRenewal(state, msg){
        state.cardRenewal = msg;
    },
    setOrderInfo(state, msg){
        state.orderInfo = msg;
    },
    setCardIccid(state, msg){
        state.cardIccid = msg;
    },
    setUserPoolCard(state, msg){
        state.userPoolCard = msg;
    },
    // Tabs视图和缓存
    setVisitedViews(state, msg){
        state.visitedViews = msg;
    },
    setCachedViews(state, msg){
        state.cachedViews = msg;
    },
    //路由表
    setRouteList(state, msg){
        state.routeList = msg;
    },
    //合同编号
    setContractNumber(state, msg){
        state.contractNumber = msg;
    },
    //页面跳转带参
    setJumpParams(state, msg){
        state.JumpParams = msg;
    },

}


// WEBPACK FOOTER //
// ./src/store/mutations.js